export interface UpgradeUnlockProps {
  tabLabel: string;
  requiredTier: "growth" | "professional" | "enterprise";
}

/** #1084 item 4: the key stays `professional`; the plan is sold as Pro. */
const PLAN_LABEL: Record<UpgradeUnlockProps["requiredTier"], string> = {
  growth: "Growth",
  professional: "Pro",
  enterprise: "Enterprise",
};

/**
 * Tier-locked tab placeholder. Per MER-52 mockup: a lower tier sees an
 * upgrade prompt where a higher tier's tab would render. #1084 added
 * Essential under Growth, so Growth itself is now a required tier.
 */
export default function UpgradeUnlock(props: UpgradeUnlockProps) {
  const plan = PLAN_LABEL[props.requiredTier];
  return (
    <section
      role="region"
      aria-label={`${props.tabLabel} tab is locked (requires ${plan} plan)`}
      style={{
        display: "grid",
        placeItems: "center",
        padding: 48,
        background: "var(--bg-card)",
        border: "1px dashed var(--border-subtle)",
        borderRadius: 14,
        textAlign: "center",
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginBottom: 8 }}>
          {plan.toUpperCase()} PLAN
        </div>
        <h2 style={{ fontSize: 22, marginBottom: 8 }}>Unlock {props.tabLabel}</h2>
        <p style={{ color: "var(--text-muted)", maxWidth: 420 }}>
          This tab is available on the {plan} plan. Contact your Meridian account manager to
          upgrade.
        </p>
      </div>
    </section>
  );
}
